export default __webpack_public_path__ + "static/media/fish.60d65275.svg";